import LegislativeReportCTA from './LegislativeReportCTA';

export default LegislativeReportCTA;
